/**
 * Navigation Module
 * 
 * @package RadianHub
 * @since 1.0.0
 */

export function initNavigation() {
    const nav = document.querySelector('.main-navigation');
    const navToggle = document.querySelector('.nav-toggle');
    const mobileMenu = document.querySelector('.mobile-menu');
    const navLinks = document.querySelectorAll('#primary-menu-mobile a, .mobile-menu a');
    const header = document.querySelector('.site-header');
    
    if (!nav) return;
    
    // Function to close mobile menu
    const closeMobileMenu = () => {
        if (navToggle) {
            navToggle.classList.remove('active');
            navToggle.setAttribute('aria-expanded', 'false');
        }
        if (mobileMenu) {
            mobileMenu.classList.remove('mobile-open');
        }
        document.body.classList.remove('nav-open');
    };
    
    // Mobile menu toggle
    if (navToggle && mobileMenu) {
        navToggle.addEventListener('click', (e) => {
            e.preventDefault();
            const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
            
            // Toggle aria-expanded
            navToggle.setAttribute('aria-expanded', !isExpanded);
            
            // Toggle active class on button
            navToggle.classList.toggle('active');
            
            // Toggle mobile menu visibility
            mobileMenu.classList.toggle('mobile-open');
            
            // Prevent body scroll when menu is open
            document.body.classList.toggle('nav-open', !isExpanded);
        });
    }
    
    // Close mobile menu when clicking on links
    navLinks.forEach(link => {
        link.addEventListener('click', () => {
            closeMobileMenu();
        });
    });
    
    // Close mobile menu when clicking outside
    document.addEventListener('click', (e) => {
        if (header && mobileMenu && mobileMenu.classList.contains('mobile-open')) {
            if (!header.contains(e.target)) {
                closeMobileMenu();
            }
        }
    });
    
    // Close mobile menu on window resize (if resizing to desktop)
    window.addEventListener('resize', () => {
        if (window.innerWidth >= 1024) { // lg breakpoint
            closeMobileMenu();
        }
    });

}
